import { render, staticRenderFns } from "./indic-multiselect.vue?vue&type=template&id=202b1534&"
import script from "./indic-multiselect.vue?vue&type=script&lang=ts&"
export * from "./indic-multiselect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports